let resumeData = {
  "imagebaseurl":"https://devisha.me/React-Portfolio/",
  "name": "ABC Jain",
  "role": "Frontend Developer",
  "linkedinId": "Your LinkedIn Id",
  "mailId": "Your Mail Id",
  "phoneno": "Your Phone Number",
  "roleDescription": "I like dabbling in various parts of frontend development and like to learn about new technologies, write technical articles or simply play games in my free time. Describe your role in few lines.",
  "socialLinks":[
      {
        "name":"linkedin",
        "url":"https://www.linkedin.com/",
        "className":"fa fa-linkedin"
      },
      {
        "name":"github",
        "url":"http://github.com/",
        "className":"fa fa-github"
      },
      {
        "name":"mail",
        "url":"abc@gmail.com",
        "className":"fa fa-envelope"
      },
      {
        "name":"twitter",
        "url":"https://twitter.com/",
        "className":"fa fa-twitter"
      },
      {
        "name":"instagram",
        "url":"https://www.instagram.com/",
        "className":"fa fa-instagram"
      }  
      
    ],
  "aboutme":"Write few lines about yourself describing your current status, learning, positions and many more.",
  "address":"XYZ Flats, Noida, India",
  "mail":"abc@gmail.com",
  "education":[
    {
      "UniversityName":"ABC University",
      "specialization":"Some specialization",
      "MonthOfPassing":"March",
      "YearOfPassing":"2020",
      "Achievements":"Some Achievements"
    },
    {
      "UniversityName":"ABC University",
      "specialization":"Some specialization",
      "MonthOfPassing":"March",
      "YearOfPassing":"2020",
      "Achievements":"Some Achievements"
    }
  ],
  "work":[
    {
      "CompanyName":"Some Company",
      "specialization":"Some specialization",
      "MonthOfLeaving":"Oct",
      "YearOfLeaving":"2020",
      "Achievements":"Some Achievements"
    },
    {
      "CompanyName":"Some Company",
      "specialization":"Some specialization",
      "MonthOfLeaving":"Oct",
      "YearOfLeaving":"2020",
      "Achievements":"Some Achievements"
    }
  ],
  "skillsDescription":"Your skills here",
  "skills":[
    {
      "skillname":"HTML5"
    },
    {
      "skillname":"CSS"
    },
    {
      "skillname":"Reactjs"
    },
    {
      "skillname":"MongoDB"
    }
  ],
  "portfolio":[
    {
      "name":"project1",
      "description":"mobileapp",
      "imgurl":"images/portfolio/phone.jpg",
      "github":"https://github.com/"
    },
    {
      "name":"project2",
      "description":"mobileapp",
      "imgurl":"images/portfolio/project.jpg",
      "github":"https://github.com/"
    },
    {
      "name":"project3",
      "description":"mobileapp",
      "imgurl":"images/portfolio/project2.png",
      "github":"https://github.com/"
    },
    {
      "name":"project4",
      "description":"mobileapp",
      "imgurl":"images/portfolio/phone.jpg",
      "github":"https://github.com/"
    }
  ],
  "testimonials":[
    {
      "description":"This is a sample testimonial",
      "name":"Some technical guy"
    },
    {
      "description":"This is a sample testimonial",
      "name":"Some technical guy"
    }
  ]
}

export default resumeData



// WEBPACK FOOTER //
// ./src/resumeData.js